/**
 * Requested Items container
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { userSelector } from '../User/selectors';
import RequestedItems from '../../Components/RequestedItems/index.tsx';

/**
 * Properties to be provided to the Requested Items component
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  user: userSelector(state),
});

/**
 * Actions to be dispatched
 * @param {function} dispatch function to dispatch Requested Items actions
 */
const mapDispatchToProps = (dispatch) => ({});

/**
 * Connects state to the Requested Items component
 * @param {object} mapStateToProps data object to become props for the Requested Items component
 * @param {object} mapDispatchToProps Requested Items actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RequestedItems),
);
